import React from 'react'


const Heading=()=>{






  return(
  <div className='headerDiv'>
  <h1>ISS Tracker</h1>
  </div>
)
}

export default Heading
